export function getAddressInfoArray(result = []) {
  return result.reduce(
    (acc, item) => {
      acc[0].push(item.address)
      acc[1].push({
        gps: item.gps.coordinates,
        address: item.address,
      })
      return acc
    },
    [[], []],
  )
}

export function getIntersectionInfoArray(intersectionInfo = []) {
  return intersectionInfo.reduce(
    (acc, item) => {
      acc[0].push(
        `(${item.town}) ${item.city}${item.intersection}||${item.road}`,
      )
      acc[1].push({
        gps: item.Gps.coordinates,
        address: `${item.intersection} ${item.city}${item.intersection}||${item.road}`,
      })
      return acc
    },
    [[], []],
  )
}



// WEBPACK FOOTER //
// ./src/assets/js/tool/addressUtils.js